import { Observable } from 'rxjs';
import { IDialogApprovalAction, IReturnDialogApprovalAction } from '../../models/shared.services.interface';
import { bcpApprovalActionComponent } from './bcpApprovalAction.component';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class BcpApprovalActionService {

  dialogRef: MatDialogRef<bcpApprovalActionComponent>;

  constructor(private dialog: MatDialog) { }
  //constructor() { }
  public openDialog(serviceInput: IDialogApprovalAction): Observable<boolean> {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();

    this.dialogRef = this.dialog.open(bcpApprovalActionComponent, { data: serviceInput });
    matDialogConfig.position = { left: '0px', top: '0px' };
    this.dialogRef.updatePosition(matDialogConfig.position);

    return this.dialogRef.afterClosed();
    //Nothing can live after afterClosed.
  }
}

